// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsListWithoutTabsContainer {
  max-width: 1420px;
  padding-right: 30px;
  padding-left: 30px;
  margin-right: auto;
  margin-left: auto;
}
@media (max-width: 767.98px) {
  .newsListWithoutTabsContainer {
    padding-right: 15px;
    padding-left: 15px;
  }
}
@media (max-width: 580px) {
  .newsListWithoutTabsContainer {
    padding-right: 0;
    padding-left: 0;
  }
}

.news-list-view .hidden {
  display: none;
}
.news-list-view .loadMoreNewsButtonsContainer,
.news-list-view .loadMoreWorkhelperButtonsContainer {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 60px;
  padding-right: 15px;
  padding-left: 15px;
}
@media (max-width: 575.98px) {
  .news-list-view .loadMoreNewsButtonsContainer,
  .news-list-view .loadMoreWorkhelperButtonsContainer {
    margin-top: 30px;
  }
}
.news-list-view .loadMoreNewsButtonsContainer .btn,
.news-list-view .loadMoreWorkhelperButtonsContainer .btn {
  flex-shrink: 0;
}

.newsTabsContainer h2.underlined {
  margin: 0px 0px 68px;
}
@media (max-width: 575.98px) {
  .newsTabsContainer .news-list-view {
    margin-left: -15px;
    margin-right: -15px;
  }
}

.articleContent .subline {
  margin-bottom: 8px;
  display: inline-block;
  letter-spacing: 2.67px;
}
.articleContent .bigHeadline {
  font-size: 38px;
  line-height: 46px;
  text-transform: none;
  margin-top: 8px;
  display: inline-block;
  /* I don't know why this is needed, I just added it and it worked in IE Edge. If we remove this width, the gradient breaks in IE Edge */
  width: 100%;
  display: inline;
  background-image: linear-gradient(transparent calc(100% - 3px), #3dbea2 10px);
  background-repeat: no-repeat;
  background-size: 0% 100%;
  transition: background-size 0.2s;
}
@media (max-width: 991px) {
  .articleContent .bigHeadline {
    font-size: 30px;
    line-height: 40px;
  }
}
.articleContent .contentText p {
  font-size: 18px;
  line-height: 30px;
  color: #5f5e5c;
}
@media (max-width: 665px) {
  .articleContent .contentText p {
    margin-bottom: 11px;
  }
}
.articleContent .imageContainer:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  box-shadow: inset 0 0 0 2000px rgba(0, 31, 55, 0);
  transition: box-shadow 0.2s;
}
.articleContent:hover .imageContainer:after {
  box-shadow: inset 0 0 0 2000px rgba(0, 31, 55, 0.25);
}
.articleContent:hover .bigHeadline {
  background-size: 155px 100%;
}

#tabTools .articleItem .wPlusIconLong {
  display: inline-block;
  margin-right: 5px;
  height: 25px;
}
#tabTools .articleItem .wPlusIconLong + .iconContainer .wPlusIcon {
  display: none;
}
#tabTools .articleContent {
  display: flex;
  gap: 40px;
  height: 100%;
  padding: 30px 0px;
  transition: background-color 0.2s;
}
#tabTools .articleContent:hover {
  background-color: #f8f7f4;
}
#tabTools .articleContent:hover .priceContainer {
  margin: -30px 0;
}
#tabTools .articleContent:hover .priceCon {
  flex-wrap: wrap;
  padding-top: 40px;
}
@media (max-width: 1120px) {
  #tabTools .articleContent:hover .priceCon {
    padding-top: 0px;
  }
  #tabTools .articleContent:hover .priceContainer {
    margin: -30px 0px 0px;
  }
}
@media (max-width: 665px) {
  #tabTools .articleContent:hover .priceContainer {
    margin-top: -10px;
  }
}
#tabTools .articleContent .textContainer {
  flex: auto;
  max-width: calc(100% - 326px);
  min-width: 290px;
}
@media (max-width: 665px) {
  #tabTools .articleContent .textContainer {
    padding: 0 20px;
    max-width: 100%;
  }
}
#tabTools .articleContent .textContainer .iconContainer {
  display: inline-block;
}
#tabTools .articleContent .imageContainer {
  float: none;
  transition: transform 0.2s;
  margin-right: 20px;
  max-width: 266px;
  min-width: 266px;
}
#tabTools .articleContent .imageContainer:after {
  box-shadow: none;
}
@media (max-width: 665px) {
  #tabTools .articleContent .imageContainer {
    margin: 0 auto 10px;
  }
}
@media (max-width: 1120px) {
  #tabTools .articleContent {
    flex-wrap: wrap;
  }
  #tabTools .articleContent .priceCon {
    padding-top: 0px;
  }
  #tabTools .articleContent .priceContainer {
    padding: 10px 30px 10px;
    margin-top: -30px;
    border-left: none;
  }
}
@media (max-width: 767px) {
  #tabTools .articleContent {
    gap: 20px;
  }
}
@media (max-width: 665px) {
  #tabTools .articleContent .priceContainer {
    margin-top: -10px;
    padding: 10px 20px 20px;
    border-bottom: 1px solid #e0ddd6;
    max-width: 100%;
    width: 100%;
  }
}
#tabTools .priceCon {
  flex-wrap: wrap;
  padding-top: 10px;
  transition: padding-top 0.2s;
}
#tabTools .flags {
  display: flex;
  margin-bottom: 20px;
  position: absolute;
  top: 20px;
  flex-direction: column;
  right: -10px;
  gap: 10px;
  color: white;
}
#tabTools .inAbo {
  margin-bottom: 0px;
}

.priceContainer {
  border-left: 1px solid #e0ddd6;
  padding: 40px 50px 20px;
  min-width: 300px;
  max-width: 300px;
  transition: margin 0.2s;
}

.imageContainer.noImage {
  display: none;
}
.imageContainer .iconContainer {
  display: none;
}
@media (max-width: 991px) {
  .imageContainer .iconContainer {
    display: block;
    position: absolute;
    top: 0px;
    left: 10px;
  }
}
@media (max-width: 580px) {
  .imageContainer .iconContainer {
    display: none;
  }
}

.textContainer .iconContainer {
  margin-top: -5px;
  margin-bottom: 18px;
}
@media (max-width: 991px) {
  .textContainer .iconContainer {
    display: none;
  }
}
@media (max-width: 580px) {
  .textContainer .iconContainer {
    display: block;
  }
}
.textContainer p.truncate2Lines {
  margin-bottom: 0px;
}
@media (max-width: 580px) {
  .textContainer p.truncate2Lines {
    margin-bottom: 20px;
    -webkit-line-clamp: 6;
  }
}
@media (max-width: 580px) {
  .textContainer {
    padding: 0 15px;
  }
}

@media (max-width: 991px) {
  .imageContainer.noImage + .textContainer .iconContainer {
    display: block;
  }
}

.relatedCategorys {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  list-style: none;
  margin-top: 58px;
  margin-bottom: 52px;
}
@media (max-width: 600px) {
  .relatedCategorys {
    margin-bottom: 22px;
    gap: 15px;
  }
}
.relatedCategorys li {
  padding: 0 !important;
  margin: 0 !important;
}
.relatedCategorys li:before {
  content: none !important;
}
.relatedCategorys li a {
  padding: 15px 32px 13px;
  border: solid 2px #e0ddd6;
  color: #5f5e5c;
  display: block;
  font-weight: bold;
  font-size: 18px;
  transition: background-color 0.4s;
}
@media (max-width: 600px) {
  .relatedCategorys li a {
    width: 100%;
  }
}
.relatedCategorys li a:hover {
  background-color: #e0ddd6;
}
@media (max-width: 600px) {
  .relatedCategorys li {
    width: 100%;
    text-align: center;
  }
}

.relatedCategoryMargins {
  margin-top: 48px;
  margin-bottom: 0px !important;
}

.articleItem .flag-new,
.articleItem .flag-update {
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 2px 8px;
  background-color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  color: #223755;
  text-transform: uppercase;
}
.articleItem .wPlusIconLong {
  position: relative;
  top: -6px;
  right: 0px;
  display: inline-block;
}
@media (max-width: 991px) {
  .articleItem .wPlusIconLong {
    display: none;
  }
}
@media (max-width: 580px) {
  .articleItem .wPlusIconLong {
    display: inline-block;
  }
}
.articleItem .wPlusIconLong + .iconContainer {
  display: inline-block;
  top: -5px;
}
@media (max-width: 991px) {
  .articleItem .wPlusIconLong + .iconContainer {
    display: none;
  }
}
@media (max-width: 580px) {
  .articleItem .wPlusIconLong + .iconContainer {
    display: inline-block;
  }
}
@media (min-width: 991px) {
  .articleItem .wPlusIconLong + .iconContainer .wPlusIcon {
    display: none;
  }
}
@media (max-width: 580px) {
  .articleItem .wPlusIconLong + .iconContainer .wPlusIcon {
    display: none;
  }
}
.articleItem .imageContainer .wPlusIconLong {
  position: absolute;
  top: 10px;
  left: 10px;
  display: none;
  z-index: 5;
}
@media (max-width: 991px) {
  .articleItem .imageContainer .wPlusIconLong {
    display: block;
  }
}
@media (max-width: 767px) {
  .articleItem .imageContainer .wPlusIconLong {
    display: none;
  }
}
.articleItem .imageContainer .iconContainer {
  top: 4.5px;
}
.articleItem .imageContainer .wPlusIconLong + .iconContainer {
  display: none;
  left: 164px;
}
@media (max-width: 991px) {
  .articleItem .imageContainer .wPlusIconLong + .iconContainer {
    display: block;
  }
}
@media (max-width: 767px) {
  .articleItem .imageContainer .wPlusIconLong + .iconContainer {
    left: 10px;
  }
}
@media (max-width: 580px) {
  .articleItem .imageContainer .wPlusIconLong + .iconContainer {
    display: none;
  }
}
@media (min-width: 767px) {
  .articleItem .imageContainer .wPlusIconLong + .iconContainer .wPlusIcon {
    display: none;
  }
}

.newsListContainer {
  margin-top: 50px;
}
.newsListContainer :last-child {
  margin-bottom: 0;
}

.fakelink {
  position: relative;
  display: inline-block;
  font-weight: bold;
  color: #3dbea2 !important;
}

.fakelink:after {
  position: absolute;
  bottom: 0px;
  left: 0;
  content: "";
  height: 2px;
  width: 30%;
  background-color: #3dbea2;
  transition: width 0.4s;
  display: block;
}`, "",{"version":3,"sources":["webpack://./build/scss/_news-list.scss","webpack://./build/scss/bootstrap/mixins/_breakpoints.scss","webpack://./build/scss/_variables.scss"],"names":[],"mappings":"AAKA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAJJ;ACmEI;EDpEJ;IAQQ,mBAAA;IACA,kBAAA;EAHN;AACF;AAKI;EAZJ;IAaQ,gBAAA;IACA,eAAA;EAFN;AACF;;AAMI;EACI,aAAA;AAHR;AAMI;;EAEI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAJR;ACyCI;ED7CA;;IAWQ,gBAAA;EAFV;AACF;AAIQ;;EACI,cAAA;AADZ;;AAOI;EAGI,oBAAA;AANR;AC2BI;EDjBI;IACI,kBAAA;IACA,mBAAA;EAPV;AACF;;AAyBI;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;AAtBR;AAyBI;EACI,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EAiBA,uIAAA;EACA,WAAA;EACA,eAAA;EACA,6EAAA;EACA,4BAAA;EACA,wBAAA;EACA,gCAAA;AAvCR;AAkBQ;EAPJ;IAQQ,eAAA;IACA,iBAAA;EAfV;AACF;AAoCI;EACI,eAAA;EACA,iBAAA;EACA,cE9EK;AF4Cb;AAoCQ;EALJ;IAMQ,mBAAA;EAjCV;AACF;AAoCI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,iDAAA;EACA,2BAAA;AAlCR;AAsCQ;EACI,oDAAA;AApCZ;AA2CQ;EACI,2BAAA;AAzCZ;;AAkDQ;EACI,qBAAA;EACA,iBAAA;EACA,YAAA;AA/CZ;AAiDY;EACI,aAAA;AA/ChB;AA4DI;EACI,aAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,iCAAA;AA1DR;AA4DQ;EACI,yBEnKD;AFyGX;AAgEY;EACI,eAAA;AA9DhB;AAiEY;EACI,eAAA;EACA,iBAAA;AA/DhB;AAkEY;EACI;IACI,gBAAA;EAhElB;EAmEc;IACI,qBAAA;EAjElB;AACF;AAoEY;EACI;IACI,iBAAA;EAlElB;AACF;AAsEQ;EACI,UAAA;EACA,6BAAA;EACA,gBAAA;AApEZ;AAsEY;EALJ;IAMQ,eAAA;IACA,eAAA;EAnEd;AACF;AAqEY;EACI,qBAAA;AAnEhB;AAuEQ;EACI,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AArEZ;AAuEY;EACI,gBAAA;AArEhB;AAwEY;EAXJ;IAYQ,mBAAA;EArEd;AACF;AAwEQ;EAvEJ;IAwEQ,eAAA;EArEV;EAuEU;IACI,gBAAA;EArEd;EAwEU;IACI,uBAAA;IACA,iBAAA;IACA,iBAAA;EAtEd;AACF;AAyEQ;EArFJ;IAsFQ,SAAA;EAtEV;AACF;AAwEQ;EACI;IACI,iBAAA;IACA,uBAAA;IACA,gCAAA;IACA,eAAA;IACA,WAAA;EAtEd;AACF;AA0EI;EACI,eAAA;EACA,iBAAA;EACA,4BAAA;AAxER;AA2EI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;AAzER;AA4EI;EACI,kBAAA;AA1ER;;AA8EA;EACI,8BAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AA3EJ;;AA+FI;EACI,aAAA;AA5FR;AA+FI;EACI,aAAA;AA7FR;AA+FQ;EAHJ;IAIQ,cAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;EA5FV;AACF;AA8FQ;EAVJ;IAWQ,aAAA;EA3FV;AACF;;AAgGI;EACI,gBAAA;EACA,mBAAA;AA7FR;AA+FQ;EAJJ;IAKQ,aAAA;EA5FV;AACF;AA8FQ;EARJ;IASQ,cAAA;EA3FV;AACF;AA8FI;EACI,kBAAA;AA5FR;AA8FQ;EAHJ;IAIQ,mBAAA;IACA,qBAAA;EA3FV;AACF;AA8FI;EAvBJ;IAwBQ,eAAA;EA3FN;AACF;;AA+FI;EADJ;IAEQ,cAAA;EA3FN;AACF;;AA8FA;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AA3FJ;AA6FI;EATJ;IAUQ,mBAAA;IACA,SAAA;EA1FN;AACF;AA4FI;EA4BI,qBAAA;EACA,oBAAA;AArHR;AAyFQ;EACI,wBAAA;AAvFZ;AA0FQ;EACI,uBAAA;EACA,yBAAA;EACA,cErWC;EFsWD,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iCAAA;AAxFZ;AA0FY;EATJ;IAUQ,WAAA;EAvFd;AACF;AAyFY;EACI,yBEnYL;AF4SX;AA2FQ;EAvBJ;IAwBQ,WAAA;IACA,kBAAA;EAxFV;AACF;;AA+FA;EACI,gBAAA;EACA,6BAAA;AA5FJ;;AAgGI;;EAEI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;AA7FR;AAgGI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;AA9FR;AAgGQ;EANJ;IAOQ,aAAA;EA7FV;AACF;AA+FQ;EAVJ;IAWQ,qBAAA;EA5FV;AACF;AA+FI;EACI,qBAAA;EACA,SAAA;AA7FR;AA+FQ;EAJJ;IAKQ,aAAA;EA5FV;AACF;AA8FQ;EARJ;IASQ,qBAAA;EA3FV;AACF;AA+FQ;EADJ;IAEQ,aAAA;EA5FV;AACF;AA8FQ;EALJ;IAMQ,aAAA;EA3FV;AACF;AA+FQ;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;AA7FZ;AA+FY;EAPJ;IAQQ,cAAA;EA5Fd;AACF;AA6FY;EAVJ;IAWQ,aAAA;EA1Fd;AACF;AA6FQ;EACI,UAAA;AA3FZ;AA8FQ;EACI,aAAA;EACA,WAAA;AA5FZ;AA8FY;EAJJ;IAKQ,cAAA;EA3Fd;AACF;AA4FY;EAPJ;IAQQ,UAAA;EAzFd;AACF;AA0FY;EAVJ;IAWQ,aAAA;EAvFd;AACF;AA2FY;EADJ;IAEQ,aAAA;EAxFd;AACF;;AA6FA;EACI,gBAAA;AA1FJ;AA4FI;EACI,gBAAA;AA1FR;;AA8FA;EACI,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;AA3FJ;;AA8FA;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,yBErgBI;EFsgBJ,sBAAA;EACA,cAAA;AA3FJ","sourcesContent":["@import 'variables';\r\n@import 'bootstrap/functions';\r\n@import 'bootstrap/variables';\r\n@import 'bootstrap/mixins';\r\n\r\n.newsListWithoutTabsContainer {\r\n    max-width: 1420px;\r\n    padding-right: 30px;\r\n    padding-left: 30px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n\r\n    @include media-breakpoint-down(sm) {\r\n        padding-right: 15px;\r\n        padding-left: 15px;\r\n    }\r\n\r\n    @media (max-width: 580px) {\r\n        padding-right: 0;\r\n        padding-left: 0;\r\n    }\r\n}\r\n\r\n.news-list-view {\r\n    .hidden {\r\n        display: none;\r\n    }\r\n\r\n    .loadMoreNewsButtonsContainer,\r\n    .loadMoreWorkhelperButtonsContainer {\r\n        display: flex;\r\n        justify-content: center;\r\n        flex-wrap: wrap;\r\n        gap: 20px;\r\n        margin-top: 60px;\r\n        padding-right: 15px;\r\n        padding-left: 15px;\r\n\r\n        @include media-breakpoint-down(xs) {\r\n            margin-top: 30px;\r\n        }\r\n\r\n        .btn {\r\n            flex-shrink: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.newsTabsContainer {\r\n    h2.underlined {\r\n        // font-size: 30px;\r\n        // line-height: 40px;\r\n        margin: 0px 0px 68px;\r\n    }\r\n\r\n    @include media-breakpoint-down(xs) {\r\n        .news-list-view {\r\n            margin-left: -15px;\r\n            margin-right: -15px;\r\n        }\r\n    }\r\n}\r\n\r\n.articleContent {\r\n    // .smallHeadline {\r\n    //     margin-top: 1px;\r\n    //     font-size: 16px;\r\n    //     line-height: 20px;\r\n    //     text-transform: uppercase;\r\n    //     margin-bottom: 21px;\r\n    //     hyphens: auto;\r\n\r\n    //     @media (max-width: 580px) {\r\n    //         margin-bottom: 12px;\r\n    //     }\r\n    // }\r\n\r\n    .subline {\r\n        margin-bottom: 8px;\r\n        display: inline-block;\r\n        letter-spacing: 2.67px;\r\n    }\r\n\r\n    .bigHeadline {\r\n        font-size: 38px;\r\n        line-height: 46px;\r\n        text-transform: none;\r\n        margin-top: 8px;\r\n        display: inline-block;\r\n\r\n        @media (max-width: 991px) {\r\n            font-size: 30px;\r\n            line-height: 40px;\r\n        }\r\n\r\n        //&:after {\r\n        //    content: '';\r\n        //    height: 2px;\r\n        //    background: $green;\r\n        //    width: 0%;\r\n        //    display: block;\r\n        //    transition: width 0.4s;\r\n        //}\r\n\r\n\r\n        /* I don't know why this is needed, I just added it and it worked in IE Edge. If we remove this width, the gradient breaks in IE Edge */\r\n        width: calc(100%);\r\n        display: inline;\r\n        background-image: linear-gradient(transparent calc(100% - 3px), $green 10px);\r\n        background-repeat: no-repeat;\r\n        background-size: 0% 100%;\r\n        transition: background-size 0.2s;\r\n    }\r\n\r\n    .contentText p {\r\n        font-size: 18px;\r\n        line-height: 30px;\r\n        color: $body-color;\r\n\r\n        @media (max-width: 665px) {\r\n            margin-bottom: 11px;\r\n        }\r\n    }\r\n\r\n    .imageContainer:after {\r\n        content: '';\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        box-shadow: inset 0 0 0 2000px rgba(0, 31, 55, 0);\r\n        transition: box-shadow 0.2s;\r\n    }\r\n\r\n    &:hover {\r\n        .imageContainer:after {\r\n            box-shadow: inset 0 0 0 2000px rgba(0, 31, 55, 0.25);\r\n        }\r\n\r\n        .bigHeadline:after {\r\n        //    width: 33%;\r\n        }\r\n\r\n        .bigHeadline {\r\n            background-size: 155px 100%;\r\n        }\r\n    }\r\n}\r\n\r\n#tabTools {\r\n    .articleItem {\r\n        // margin-bottom: 60px;\r\n\r\n        .wPlusIconLong {\r\n            display: inline-block;\r\n            margin-right: 5px;\r\n            height: 25px;\r\n\r\n            & + .iconContainer .wPlusIcon{\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        // @media (max-width: 665px) {\r\n        //     margin-bottom: 0px;\r\n\r\n        //     &:last-child {\r\n        //         margin-bottom: 40px;\r\n        //     }\r\n        // }\r\n    }\r\n\r\n    .articleContent {\r\n        display: flex;\r\n        gap: 40px;\r\n        height: 100%;\r\n        padding: 30px 0px;\r\n        transition: background-color 0.2s;\r\n\r\n        &:hover {\r\n            background-color: $gray-100;\r\n\r\n            .imageContainer {\r\n                //transform: translateX(20px);\r\n            }\r\n\r\n            .priceContainer {\r\n                margin: -30px 0;\r\n            }\r\n\r\n            .priceCon{\r\n                flex-wrap: wrap;\r\n                padding-top: 40px;\r\n            }\r\n\r\n            @media (max-width: 1120px) {\r\n                .priceCon{\r\n                    padding-top: 0px;\r\n                }\r\n\r\n                .priceContainer {\r\n                    margin: -30px 0px 0px;\r\n                }\r\n            }\r\n\r\n            @media (max-width: 665px) {\r\n                .priceContainer {\r\n                    margin-top: -10px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .textContainer {\r\n            flex: auto;\r\n            max-width: calc(100% - 326px);\r\n            min-width: 290px;\r\n\r\n            @media (max-width: 665px) {\r\n                padding: 0 20px;\r\n                max-width: 100%;\r\n            }\r\n\r\n            .iconContainer {\r\n                display: inline-block;\r\n            }\r\n        }\r\n\r\n        .imageContainer {\r\n            float: none;\r\n            transition: transform 0.2s;\r\n            margin-right: 20px;\r\n            max-width: 266px;\r\n            min-width: 266px;\r\n\r\n            &:after {\r\n                box-shadow: none;\r\n            }\r\n\r\n            @media (max-width: 665px) {\r\n                margin: 0 auto 10px;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 1120px) {\r\n            flex-wrap: wrap;\r\n\r\n            .priceCon{\r\n                padding-top: 0px;\r\n            }\r\n\r\n            .priceContainer {\r\n                padding: 10px 30px 10px;\r\n                margin-top: -30px;\r\n                border-left: none;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 767px) {\r\n            gap: 20px;\r\n        }\r\n\r\n        @media (max-width: 665px) {\r\n            .priceContainer {\r\n                margin-top: -10px;\r\n                padding: 10px 20px 20px;\r\n                border-bottom: 1px solid $gray-300;\r\n                max-width: 100%;\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n\r\n    .priceCon{\r\n        flex-wrap: wrap;\r\n        padding-top: 10px;\r\n        transition: padding-top 0.2s;\r\n    }\r\n\r\n    .flags {\r\n        display: flex;\r\n        margin-bottom: 20px;\r\n        position: absolute;\r\n        top: 20px;\r\n        flex-direction: column;\r\n        right: -10px;\r\n        gap: 10px;\r\n        color: white;\r\n    }\r\n\r\n    .inAbo {\r\n        margin-bottom: 0px;\r\n    }\r\n}\r\n\r\n.priceContainer {\r\n    border-left: 1px solid $gray-300;\r\n    padding: 40px 50px 20px;\r\n    min-width: 300px;\r\n    max-width: 300px;\r\n    transition: margin 0.2s;\r\n}\r\n\r\n.imageContainer {\r\n    // margin-right: 40px;\r\n    // float: left;\r\n    // position: relative;\r\n\r\n    // @media (max-width: 991px) {\r\n    //     max-width: 40%;\r\n    //     margin-right: 20px;\r\n    // }\r\n\r\n    // @media (max-width: 580px) {\r\n    //     max-width: 100%;\r\n    //     width: auto;\r\n    //     margin-right: 0px;\r\n    //     margin-bottom: 40px;\r\n    // }\r\n\r\n    &.noImage {\r\n        display: none;\r\n    }\r\n\r\n    .iconContainer {\r\n        display: none;\r\n\r\n        @media (max-width: 991px) {\r\n            display: block;\r\n            position: absolute;\r\n            top: 0px;\r\n            left: 10px;\r\n        }\r\n\r\n        @media (max-width: 580px) {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n.textContainer {\r\n    .iconContainer {\r\n        margin-top: -5px;\r\n        margin-bottom: 18px;\r\n\r\n        @media (max-width: 991px) {\r\n            display: none;\r\n        }\r\n\r\n        @media (max-width: 580px) {\r\n            display: block;\r\n        }\r\n    }\r\n\r\n    p.truncate2Lines {\r\n        margin-bottom: 0px;\r\n\r\n        @media (max-width: 580px) {\r\n            margin-bottom: 20px;\r\n            -webkit-line-clamp: 6;\r\n        }\r\n    }\r\n\r\n    @media (max-width: 580px) {\r\n        padding: 0 15px;\r\n    }\r\n}\r\n\r\n.imageContainer.noImage + .textContainer .iconContainer {\r\n    @media (max-width: 991px) {\r\n        display: block;\r\n    }\r\n}\r\n\r\n.relatedCategorys {\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n    gap: 30px;\r\n    list-style: none;\r\n    margin-top: 58px;\r\n    margin-bottom: 52px;\r\n\r\n    @media (max-width: 600px) {\r\n        margin-bottom: 22px;\r\n        gap: 15px;\r\n    }\r\n\r\n    li {\r\n        &:before {\r\n            content: none !important;\r\n        }\r\n\r\n        a {\r\n            padding: 15px 32px 13px;\r\n            border: solid 2px $gray-300;\r\n            color: $body-color;\r\n            display: block;\r\n            font-weight: bold;\r\n            font-size: 18px;\r\n            transition: background-color 0.4s;\r\n\r\n            @media (max-width: 600px) {\r\n                width: 100%;\r\n            }\r\n\r\n            &:hover {\r\n                background-color: $gray-300;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 600px) {\r\n            width: 100%;\r\n            text-align: center;\r\n        }\r\n\r\n        padding: 0 !important;\r\n        margin: 0 !important;\r\n    }\r\n}\r\n\r\n.relatedCategoryMargins {\r\n    margin-top: 48px;\r\n    margin-bottom: 0px !important;\r\n}\r\n\r\n.articleItem {\r\n    .flag-new,\r\n    .flag-update {\r\n        position: absolute;\r\n        top: 16px;\r\n        left: 16px;\r\n        padding: 2px 8px;\r\n        background-color: #fff;\r\n        font-size: 18px;\r\n        font-weight: 700;\r\n        line-height: 1;\r\n        color: #223755;\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    .wPlusIconLong {\r\n        position: relative;\r\n        top: -6px;\r\n        right: 0px;\r\n        display: inline-block;\r\n\r\n        @media (max-width: 991px) {\r\n            display: none;\r\n        }\r\n\r\n        @media (max-width: 580px) {\r\n            display: inline-block;\r\n        }\r\n    }\r\n\r\n    .wPlusIconLong + .iconContainer {\r\n        display: inline-block;\r\n        top: -5px;\r\n\r\n        @media (max-width: 991px) {\r\n            display: none;\r\n        }\r\n\r\n        @media (max-width: 580px) {\r\n            display: inline-block;\r\n        }\r\n    }\r\n\r\n    .wPlusIconLong + .iconContainer .wPlusIcon {\r\n        @media (min-width: 991px) {\r\n            display: none;\r\n        }\r\n\r\n        @media (max-width: 580px) {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .imageContainer {\r\n        .wPlusIconLong {\r\n            position: absolute;\r\n            top: 10px;\r\n            left: 10px;\r\n            display: none;\r\n            z-index: 5;\r\n\r\n            @media (max-width: 991px) {\r\n                display: block;\r\n            }\r\n            @media (max-width: 767px) {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .iconContainer {\r\n            top: 4.5px;\r\n        }\r\n\r\n        .wPlusIconLong + .iconContainer {\r\n            display: none;\r\n            left: 164px;\r\n\r\n            @media (max-width: 991px) {\r\n                display: block;\r\n            }\r\n            @media (max-width: 767px) {\r\n                left: 10px;\r\n            }\r\n            @media (max-width: 580px) {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .wPlusIconLong + .iconContainer .wPlusIcon {\r\n            @media (min-width: 767px) {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.newsListContainer {\r\n    margin-top: 50px;\r\n\r\n    :last-child {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n.fakelink {\r\n    position: relative;\r\n    display: inline-block;\r\n    font-weight: bold;\r\n    color: $green !important;\r\n}\r\n\r\n.fakelink:after {\r\n    position: absolute;\r\n    bottom: 0px;//-10px;\r\n    left: 0;\r\n    content: '';\r\n    height: 2px;\r\n    width: 30%;\r\n    background-color: $green;\r\n    transition: width 0.4s;\r\n    display: block;\r\n}\r\n\r\n#beitrge,\r\n#expertenmeinungen,\r\n#fachexperten {\r\n    .loadMoreNewsButton {\r\n        //margin-top: -48px;\r\n    }\r\n}\r\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02px, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","//\r\n// Project specific variables\r\n// --------------------------------------------------\r\n\r\n//== Transitions\r\n$transition-duration: 300ms !default;\r\n$transition-duration-fast: 150ms !default;\r\n\r\n$page-width:     1600px;\r\n$page-min-width:  320px;\r\n$content-width:  1420px;\r\n\r\n//\r\n// Bootstrap variables\r\n// --------------------------------------------------\r\n\r\n//== Color system\r\n$white: #ffffff;\r\n$gray-100: #f8f7f4;\r\n$gray-200: #ece9e4;\r\n$gray-300: #e0ddd6;\r\n$gray-400: #001f37;\r\n\r\n$blue: #005790;\r\n$blue-light: #aebacc;\r\n$blue-dark: #003151;\r\n$blue-medium: #004471;\r\n$green: #3dbea2;\r\n$green-dark: #228d76;\r\n$red: #ea7c7c;\r\n$red-light: #ed8f8f;\r\n$brown: #d8bc91;\r\n\r\n$primary: $blue;\r\n$secondary: $green;\r\n\r\n\r\n\r\n//== Body\r\n$body-color: #5f5e5c;\r\n\r\n//== Components\r\n$line-height-base: 1.7;\r\n$line-height-lg: 1.7;\r\n$line-height-sm: 1.7;\r\n\r\n//== Fonts\r\n$font-size-base: 1.25rem; // If we don't use rem, we get compile errors...\r\n\r\n//== Fonts\r\n$font-family-sans-serif: 'Gudea', sans-serif;\r\n\r\n$h1-font-size:   38px;\r\n$h1-line-height: 46px;\r\n\r\n$h2-font-size:   30px;\r\n$h2-line-height: 46px;\r\n\r\n// $h3-font-size:   20px;\r\n// $h3-line-height: 30px;\r\n\r\n//== Links\r\n$link-hover-decoration: none;\r\n\r\n$fullwidth-margin-desktop: 120px;\r\n// $fullwidth-margin-desktop: 90px;\r\n$fullwidth-margin-tablet: 70px;\r\n$fullwidth-margin-smartphone: 60px;\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
